import * as React from 'react';
import { FixMeLater } from '../../utils';
import { useStyles } from './Flag.styles';
import { Styler, StylerBaseProps } from '../Styler';
import { FlagColor, useComponentDefaultProps } from '../../theming';

export interface FlagProps extends StylerBaseProps {
    /**
     * The label which will be displayed on the chip.
     */
    children?: React.ReactNode;

    /**
     * The colour of the flag.
     * @default neutral
     */
    color?: FlagColor;

    /**
     * The style variant.
     * @default default
     */
    variant?: 'default' | 'hero';
}

const defaultProps: Partial<FlagProps> = {
    color: 'neutral',
    variant: 'default',
};

export const Flag: React.ForwardRefExoticComponent<FlagProps & React.RefAttributes<HTMLElement>> = React.forwardRef(
    function Flag(props: FlagProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const {
            children: label,
            color = 'neutral',
            variant = 'default',
            ...other
        } = useComponentDefaultProps('Flag', defaultProps, props);

        const { styles } = useStyles({ color, variant });

        return (
            <Styler ref={ref} baseStyles={styles.root} {...other}>
                {label}
            </Styler>
        );
    }
);
